/* export const PREFIX_PHONE_LIST = {
  SPAIN_PHONE: '+34',
  GERMAN_PHONE: '+49',
  UK_PHONE: '+44',
  FRENCH_PHONE: '+33',
  BELGIAN_PHONE: '+32',
  DANISH_PHONE: '+45',
  IRISH_PHONE: '+353',
  NORWEGIAN_PHONE: '+47',
  SWEDISH_PHONE: '+46',
  DUTCH_PHONE: '+31',
  SWISS_PHONE: '+41',
  AUSTRIAN_PHONE: '+43',
  AFGHANISTAN_PHONE: '+93',
  ALBANIA_PHONE: '+355',
  ALGERIA_PHONE: '+213',
  ANDORRA_PHONE: '+376',
  ANGOLA_PHONE: '+244',
  ANGUILLA_PHONE: '+1 264',
  ANTARCTICA_PHONE: '+672',
  ANTIGUA_AND_BARBUDA_PHONE: '+1 268',
  SAUDI_ARABIA_PHONE: '+966',
  ARGENTINA_PHONE: '+54',
  ARMENIA_PHONE: '+374',
  ARUBA_PHONE: '+297',
  AUSTRALIA_PHONE: '+61',
  AUSTRIA_PHONE: '+43',
  AZERBAIJAN_PHONE: '+994',
  BELGIUM_PHONE: '+32',
  BAHAMAS_PHONE: '+1 242',
  BAHRAIN_PHONE: '+973',
  BANGLADESH_PHONE: '+880',
  BARBADOS_PHONE: '+1 246',
  BELIZE_PHONE: '+501',
  BENIN_PHONE: '+229',
  BHUTAN_PHONE: '+975',
  BELARUS_PHONE: '+375',
  MYANMAR_PHONE: '+95',
  BOLIVIA_PHONE: '+591',
  BOSNIA_AND_HERZEGOVINA_PHONE: '+387',
  BOTSWANA_PHONE: '+267',
  BRAZIL_PHONE: '+55',
  BRUNEI_PHONE: '+673',
  BULGARIA_PHONE: '+359',
  BURKINA_FASO_PHONE: '+226',
  BURUNDI_PHONE: '+257',
  CAPE_VERDE_PHONE: '+238',
  CAMBODIA_PHONE: '+855',
  CAMEROON_PHONE: '+237',
  CANADA_PHONE: '+1',
  CHAD_PHONE: '+235',
  CHILE_PHONE: '+56',
  CHINA_PHONE: '+86',
  CYPRUS_PHONE: '+357',
  VATICAN_CITY_STATE_PHONE: '+39',
  COLOMBIA_PHONE: '+57',
  COMOROS_PHONE: '+269',
  REPUBLIC_OF_THE_CONGO_PHONE: '+242',
  DEMOCRATIC_REPUBLIC_OF_THE_CONGO_PHONE: '+243',
  NORTH_KOREA_PHONE: '+850',
  SOUTH_KOREA_PHONE: '+82',
  IVORY_COAST_PHONE: '+225',
  COSTA_RICA_PHONE: '+506',
  CROATIA_PHONE: '+385',
  CUBA_PHONE: '+53',
  CURACAO_PHONE: '+5999',
  DENMARK_PHONE: '+45',
  DOMINICA_PHONE: '+1 767',
  ECUADOR_PHONE: '+593',
  EGYPT_PHONE: '+20',
  EL_SALVADOR_PHONE: '+503',
  UNITED_ARAB_EMIRATES_PHONE: '+971',
  ERITREA_PHONE: '+291',
  SLOVAKIA_PHONE: '+421',
  SLOVENIA_PHONE: '+386',
  UNITED_STATES_OF_AMERICA_PHONE: '+1',
  ESTONIA_PHONE: '+372',
  ETHIOPIA_PHONE: '+251',
  PHILIPPINES_PHONE: '+63',
  FINLAND_PHONE: '+358',
  FIJI_PHONE: '+679',
  FRANCE_PHONE: '+33',
  GABON_PHONE: '+241',
  GAMBIA_PHONE: '+220',
  GEORGIA_PHONE: '+995',
  GHANA_PHONE: '+233',
  GIBRALTAR_PHONE: '+350',
  GRENADA_PHONE: '+1 473',
  GREECE_PHONE: '+30',
  GREENLAND_PHONE: '+299',
  GUADELOUPE_PHONE: '+590',
  GUAM_PHONE: '+1 671',
  GUATEMALA_PHONE: '+502',
  FRENCH_GUIANA_PHONE: '+594',
  GUERNSEY_PHONE: '+44',
  GUINEA_PHONE: '+224',
  EQUATORIAL_GUINEA_PHONE: '+240',
  GUINEA_BISSAU_PHONE: '+245',
  GUYANA_PHONE: '+592',
  HAITI_PHONE: '+509',
  HONDURAS_PHONE: '+504',
  HONG_KONG_PHONE: '+852',
  HUNGARY_PHONE: '+36',
  INDIA_PHONE: '+91',
  INDONESIA_PHONE: '+62',
  IRAN_PHONE: '+98',
  IRAQ_PHONE: '+964',
  IRELAND_PHONE: '+353',
  ISLE_OF_MAN_PHONE: '+44',
  CHRISTMAS_ISLAND_PHONE: '+61',
  NORFOLK_ISLAND_PHONE: '+672',
  ICELAND_PHONE: '+354',
  BERMUDA_ISLANDS_PHONE: '+1 441',
  CAYMAN_ISLANDS_PHONE: '+1 345',
  COCOS_KEELING_ISLANDS_PHONE: '+61',
  COOK_ISLANDS_PHONE: '+682',
  ALAND_ISLANDS_PHONE: '+358',
  FAROE_ISLANDS_PHONE: '+298',
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS_PHONE: '+500',
  HEARD_ISLAND_AND_MCDONALD_ISLANDS_PHONE: 'N/A',
  MALDIVES_PHONE: '+960',
  FALKLAND_ISLANDS_MALVINAS_PHONE: '+500',
  NORTHERN_MARIANA_ISLANDS_PHONE: '+1 670',
  MARSHALL_ISLANDS_PHONE: '+692',
  PITCAIRN_ISLANDS_PHONE: 'N/A',
  SOLOMON_ISLANDS_PHONE: '+677',
  TURKS_AND_CAICOS_ISLANDS_PHONE: '+1 649',
  UNITED_STATES_MINOR_OUTLYING_ISLANDS_PHONE: '+246',
  VIRGIN_ISLANDS_BRITISH_PHONE: '+1 284',
  UNITED_STATES_VIRGIN_ISLANDS_PHONE: '+1 340',
  ISRAEL_PHONE: '+972',
  ITALY_PHONE: '+39',
  JAMAICA_PHONE: '+1 876',
  JAPAN_PHONE: '+81',
  JERSEY_PHONE: '+44',
  JORDAN_PHONE: '+962',
  KAZAKHSTAN_PHONE: '+7',
  KENYA_PHONE: '+254',
  KYRGYZSTAN_PHONE: '+996',
  KIRIBATI_PHONE: '+686',
  KUWAIT_PHONE: '+965',
  LEBANON_PHONE: '+961',
  LAOS_PHONE: '+856',
  LESOTHO_PHONE: '+266',
  LATVIA_PHONE: '+371',
  LIBERIA_PHONE: '+231',
  LIBYA_PHONE: '+218',
  LIECHTENSTEIN_PHONE: '+423',
  LITHUANIA_PHONE: '+370',
  LUXEMBOURG_PHONE: '+352',
  MEXICO_PHONE: '+52',
  MONACO_PHONE: '+377',
  MACAO_PHONE: '+853',
  MACEDONIA_PHONE: '+389',
  MADAGASCAR_PHONE: '+261',
  MALAYSIA_PHONE: '+60',
  MALAWI_PHONE: '+265',
  MALI_PHONE: '+223',
  MALTA_PHONE: '+356',
  MOROCCO_PHONE: '+212',
  MARTINIQUE_PHONE: '+596',
  MAURITIUS_PHONE: '+230',
  MAURITANIA_PHONE: '+222',
  MAYOTTE_PHONE: '+262',
  FEDERATED_STATES_OF_MICRONESIA_PHONE: '+691',
  MOLDOVA_PHONE: '+373',
  MONGOLIA_PHONE: '+976',
  MONTENEGRO_PHONE: '+382',
  MONTSERRAT_PHONE: '+1 664',
  MOZAMBIQUE_PHONE: '+258',
  NAMIBIA_PHONE: '+264',
  NAURU_PHONE: '+674',
  NEPAL_PHONE: '+977',
  NICARAGUA_PHONE: '+505',
  NIGER_PHONE: '+227',
  NIGERIA_PHONE: '+234',
  NIUE_PHONE: '+683',
  NORWAY_PHONE: '+47',
  NEW_CALEDONIA_PHONE: '+687',
  NEW_ZEALAND_PHONE: '+64',
  OMAN_PHONE: '+968',
  NETHERLANDS_PHONE: '+31',
  PAKISTAN_PHONE: '+92',
  PALAU_PHONE: '+680',
  PALESTINE_PHONE: '+970',
  PANAMA_PHONE: '+507',
  PAPUA_NEW_GUINEA_PHONE: '+675',
  PARAGUAY_PHONE: '+595',
  PERU_PHONE: '+51',
  FRENCH_POLYNESIA_PHONE: '+689',
  POLAND_PHONE: '+48',
  PORTUGAL_PHONE: '+351',
  PUERTO_RICO_PHONE: '+1',
  QATAR_PHONE: '+974',
  UNITED_KINGDOM_PHONE: '+44',
  CENTRAL_AFRICAN_REPUBLIC_PHONE: '+236',
  CZECH_REPUBLIC_PHONE: '+420',
  DOMINICAN_REPUBLIC_PHONE: '+1 809',
  SOUTH_SUDAN_PHONE: '+211',
  REUNION_PHONE: '+262',
  RWANDA_PHONE: '+250',
  ROMANIA_PHONE: '+40',
  RUSSIA_PHONE: '+7',
  WESTERN_SAHARA_PHONE: '+212',
  SAMOA_PHONE: '+685',
  AMERICAN_SAMOA_PHONE: '+1 684',
  SAINT_BARTHELEMY_PHONE: '+590',
  SAINT_KITTS_AND_NEVIS_PHONE: '+1 869',
  SAN_MARINO_PHONE: '+378',
  SAINT_MARTIN_FRENCH_PART_PHONE: '+1 599',
  SAINT_PIERRE_AND_MIQUELON_PHONE: '+508',
  SAINT_VINCENT_AND_THE_GRENADINES_PHONE: '+1 784',
  ASCENSION_AND_TRISTAN_DA_CUNHA_PHONE: '+290',
  SAINT_LUCIA_PHONE: '+1 758',
  SAO_TOME_AND_PRINCIPE_PHONE: '+239',
  SENEGAL_PHONE: '+221',
  SERBIA_PHONE: '+381',
  SEYCHELLES_PHONE: '+248',
  SIERRA_LEONE_PHONE: '+232',
  SINGAPORE_PHONE: '+65',
  SINT_MAARTEN_PHONE: '+1 721',
  SYRIA_PHONE: '+963',
  SOMALIA_PHONE: '+252',
  SRI_LANKA_PHONE: '+94',
  SOUTH_AFRICA_PHONE: '+27',
  SUDAN_PHONE: '+249',
  SWEDEN_PHONE: '+46',
  SWITZERLAND_PHONE: '+41',
  SURINAME_PHONE: '+597',
  SVALBARD_AND_JAN_MAYEN_PHONE: '+47',
  SWAZILAND_PHONE: '+268',
  TAJIKISTAN_PHONE: '+992',
  THAILAND_PHONE: '+66',
  TAIWAN_PHONE: '+886',
  TANZANIA_PHONE: '+255',
  BRITISH_INDIAN_OCEAN_TERRITORY_PHONE: '+246',
  FRENCH_SOUTHERN_TERRITORIES_PHONE: 'N/A',
  EAST_TIMOR_PHONE: '+670',
  TOGO_PHONE: '+228',
  TOKELAU_PHONE: '+690',
  TONGA_PHONE: '+676',
  TRINIDAD_AND_TOBAGO_PHONE: '+1 868',
  TUNISIA_PHONE: '+216',
  TURKMENISTAN_PHONE: '+993',
  TURKEY_PHONE: '+90',
  TUVALU_PHONE: '+688',
  UKRAINE_PHONE: '+380',
  UGANDA_PHONE: '+256',
  URUGUAY_PHONE: '+598',
  UZBEKISTAN_PHONE: '+998',
  VANUATU_PHONE: '+678',
  VENEZUELA_PHONE: '+58',
  VIETNAM_PHONE: '+84',
  WALLIS_AND_FUTUNA_PHONE: '+681',
  YEMEN_PHONE: '+967',
  DJIBOUTI_PHONE: '+253',
  ZAMBIA_PHONE: '+260',
  ZIMBABWE_PHONE: '+263'
} */

export const PHONE_CODES = [
  {
    country: 'alemania',
    code: '+49'
  },
  {
    country: 'españa',
    code: '+34'
  },
  {
    country: 'reino unido',
    code: '+44'
  },
  {
    country: 'francia',
    code: '+33'
  },
  {
    country: 'bélgica',
    code: '+32'
  },
  {
    country: 'dinamarca',
    code: '+45'
  },
  {
    country: 'irlanda',
    code: '+353'
  },
  {
    country: 'noruega',
    code: '+47'
  },
  {
    country: 'suecia',
    code: '+46'
  },
  {
    country: 'países bajos',
    code: '+31'
  },
  {
    country: 'suiza',
    code: '+41'
  },
  {
    country: 'austria',
    code: '+43'
  },
  // {
  //   country: 'afganistán',
  //   code: '+93'
  // },
  // {
  //   country: 'albania',
  //   code: '+355'
  // },
  // {
  //   country: 'argelia',
  //   code: '+213'
  // },
  // {
  //   country: 'andorra',
  //   code: '+376'
  // },
  // {
  //   country: 'angola',
  //   code: '+244'
  // },
  // {
  //   country: 'anguila',
  //   code: '+1264'
  // },
  // {
  //   country: 'antártida',
  //   code: '+672'
  // },
  // {
  //   country: 'antigua y barbuda',
  //   code: '+1268'
  // },
  // {
  //   country: 'arabia saudita',
  //   code: '+966'
  // },
  // {
  //   country: 'argentina',
  //   code: '+54'
  // },
  // {
  //   country: 'armenia',
  //   code: '+374'
  // },
  // {
  //   country: 'aruba',
  //   code: '+297'
  // },
  // {
  //   country: 'australia',
  //   code: '+61'
  // },
  // {
  //   country: 'austria',
  //   code: '+43'
  // },
  // {
  //   country: 'azerbaiyán',
  //   code: '+994'
  // },
  // {
  //   country: 'bélgica',
  //   code: '+32'
  // },
  // {
  //   country: 'bahamas',
  //   code: '+1242'
  // },
  // {
  //   country: 'baréin',
  //   code: '+973'
  // },
  // {
  //   country: 'bangladesh',
  //   code: '+88'
  // },
  // {
  //   country: 'barbados',
  //   code: '+1246'
  // },
  // {
  //   country: 'belice',
  //   code: '+501'
  // },
  // {
  //   country: 'benín',
  //   code: '+229'
  // },
  // {
  //   country: 'bután',
  //   code: '+975'
  // },
  // {
  //   country: 'bielorrusia',
  //   code: '+375'
  // },
  // {
  //   country: 'myanmar',
  //   code: '+95'
  // },
  // {
  //   country: 'bolivia',
  //   code: '+591'
  // },
  // {
  //   country: 'bosnia y herzegovina',
  //   code: '+387'
  // },
  // {
  //   country: 'botsuana',
  //   code: '+267'
  // },
  // {
  //   country: 'brasil',
  //   code: '+55'
  // },
  // {
  //   country: 'brunéi',
  //   code: '+673'
  // },
  // {
  //   country: 'bulgaria',
  //   code: '+359'
  // },
  // {
  //   country: 'burkina faso',
  //   code: '+226'
  // },
  // {
  //   country: 'burundi',
  //   code: '+257'
  // },
  // {
  //   country: 'cabo verde',
  //   code: '+238'
  // },
  // {
  //   country: 'camboya',
  //   code: '+855'
  // },
  // {
  //   country: 'camerún',
  //   code: '+237'
  // },
  // {
  //   country: 'canadá',
  //   code: '+1'
  // },
  // {
  //   country: 'chad',
  //   code: '+235'
  // },
  // {
  //   country: 'chile',
  //   code: '+56'
  // },
  // {
  //   country: 'china',
  //   code: '+86'
  // },
  // {
  //   country: 'chipre',
  //   code: '+357'
  // },
  // {
  //   country: 'ciudad del vaticano',
  //   code: '+39'
  // },
  // {
  //   country: 'colombia',
  //   code: '+57'
  // },
  // {
  //   country: 'comoras',
  //   code: '+269'
  // },
  // {
  //   country: 'congo',
  //   code: '+242'
  // },
  // {
  //   country: 'congo (república democrática del)',
  //   code: '+243'
  // },
  // {
  //   country: 'corea del norte',
  //   code: '+850'
  // },
  // {
  //   country: 'corea del sur',
  //   code: '+82'
  // },
  // {
  //   country: 'costa de marfil',
  //   code: '+225'
  // },
  // {
  //   country: 'costa rica',
  //   code: '+506'
  // },
  // {
  //   country: 'croacia',
  //   code: '+385'
  // },
  // {
  //   country: 'cuba',
  //   code: '+53'
  // },
  // {
  //   country: 'curazao',
  //   code: '+5999'
  // },
  // {
  //   country: 'dinamarca',
  //   code: '+45'
  // },
  // {
  //   country: 'dominica',
  //   code: '+1767'
  // },
  // {
  //   country: 'ecuador',
  //   code: '+593'
  // },
  // {
  //   country: 'egipto',
  //   code: '+20'
  // },
  // {
  //   country: 'el salvador',
  //   code: '+503'
  // },
  // {
  //   country: 'emiratos árabes unidos',
  //   code: '+971'
  // },
  // {
  //   country: 'eritrea',
  //   code: '+291'
  // },
  // {
  //   country: 'eslovaquia',
  //   code: '+421'
  // },
  // {
  //   country: 'eslovenia',
  //   code: '+386'
  // },
  // {
  //   country: 'estados unidos',
  //   code: '+1'
  // },
  // {
  //   country: 'estonia',
  //   code: '+372'
  // },
  // {
  //   country: 'etiopía',
  //   code: '+251'
  // },
  // {
  //   country: 'filipinas',
  //   code: '+63'
  // },
  {
    country: 'finlandia',
    code: '+358'
  },
  // {
  //   country: 'fiyi',
  //   code: '+679'
  // },
  // {
  //   country: 'francia',
  //   code: '+33'
  // },
  // {
  //   country: 'gabón',
  //   code: '+241'
  // },
  // {
  //   country: 'gambia',
  //   code: '+220'
  // },
  // {
  //   country: 'georgia',
  //   code: '+995'
  // },
  // {
  //   country: 'ghana',
  //   code: '+233'
  // },
  // {
  //   country: 'gibraltar',
  //   code: '+350'
  // },
  // {
  //   country: 'granada',
  //   code: '+1473'
  // },
  // {
  //   country: 'grecia',
  //   code: '+30'
  // },
  // {
  //   country: 'groenlandia',
  //   code: '+299'
  // },
  // {
  //   country: 'guadalupe',
  //   code: '+590'
  // },
  // {
  //   country: 'guam',
  //   code: '+1671'
  // },
  // {
  //   country: 'guatemala',
  //   code: '+502'
  // },
  // {
  //   country: 'guayana francesa',
  //   code: '+594'
  // },
  // {
  //   country: 'guernsey',
  //   code: '+44'
  // },
  // {
  //   country: 'guinea',
  //   code: '+224'
  // },
  // {
  //   country: 'guinea ecuatorial',
  //   code: '+240'
  // },
  // {
  //   country: 'guinea-bissau',
  //   code: '+245'
  // },
  // {
  //   country: 'guyana',
  //   code: '+592'
  // },
  // {
  //   country: 'haití',
  //   code: '+509'
  // },
  // {
  //   country: 'honduras',
  //   code: '+504'
  // },
  // {
  //   country: 'hong kong',
  //   code: '+852'
  // },
  // {
  //   country: 'hungría',
  //   code: '+36'
  // },
  // {
  //   country: 'india',
  //   code: '+91'
  // },
  // {
  //   country: 'indonesia',
  //   code: '+62'
  // },
  // {
  //   country: 'irán',
  //   code: '+98'
  // },
  // {
  //   country: 'iraq',
  //   code: '+964'
  // },
  // {
  //   country: 'irlanda',
  //   code: '+353'
  // },
  // {
  //   country: 'isla de man',
  //   code: '+44'
  // },
  // {
  //   country: 'isla de navidad',
  //   code: '+61'
  // },
  // {
  //   country: 'isla norfolk',
  //   code: '+672'
  // },
  // {
  //   country: 'islandia',
  //   code: '+354'
  // },
  // {
  //   country: 'islas bermudas',
  //   code: '+1441'
  // },
  // {
  //   country: 'islas caimán',
  //   code: '+1345'
  // },
  // {
  //   country: 'islas cocos (keeling)',
  //   code: '+61'
  // },
  // {
  //   country: 'islas cook',
  //   code: '+682'
  // },
  // {
  //   country: 'islas åland',
  //   code: '+358'
  // },
  // {
  //   country: 'islas feroe',
  //   code: '+298'
  // },
  // {
  //   country: 'islas georgias del sur y sandwich del sur',
  //   code: '+500'
  // },
  // {
  //   country: 'maldivas',
  //   code: '+960'
  // },
  // {
  //   country: 'islas malvinas',
  //   code: '+500'
  // },
  // {
  //   country: 'islas marianas del norte',
  //   code: '+1670'
  // },
  // {
  //   country: 'islas marshall',
  //   code: '+692'
  // },
  // {
  //   country: 'islas salomón',
  //   code: '+677'
  // },
  // {
  //   country: 'islas turcas y caicos',
  //   code: '+1649'
  // },
  // {
  //   country: 'islas ultramarinas menores de estados unidos',
  //   code: '+246'
  // },
  // {
  //   country: 'islas vírgenes británicas',
  //   code: '+1284'
  // },
  // {
  //   country: 'islas vírgenes de estados unidos',
  //   code: '+1340'
  // },
  // {
  //   country: 'israel',
  //   code: '+972'
  // },
  // {
  //   country: 'italia',
  //   code: '+39'
  // },
  // {
  //   country: 'jamaica',
  //   code: '+1876'
  // },
  // {
  //   country: 'japón',
  //   code: '+81'
  // },
  // {
  //   country: 'jersey',
  //   code: '+44'
  // },
  // {
  //   country: 'jordania',
  //   code: '+962'
  // },
  // {
  //   country: 'kazajistán',
  //   code: '+7'
  // },
  // {
  //   country: 'kenia',
  //   code: '+254'
  // },
  // {
  //   country: 'kirguistán',
  //   code: '+996'
  // },
  // {
  //   country: 'kiribati',
  //   code: '+686'
  // },
  // {
  //   country: 'kuwait',
  //   code: '+965'
  // },
  // {
  //   country: 'líbano',
  //   code: '+961'
  // },
  // {
  //   country: 'laos',
  //   code: '+856'
  // },
  // {
  //   country: 'lesoto',
  //   code: '+266'
  // },
  // {
  //   country: 'letonia',
  //   code: '+371'
  // },
  // {
  //   country: 'liberia',
  //   code: '+231'
  // },
  // {
  //   country: 'libia',
  //   code: '+218'
  // },
  // {
  //   country: 'liechtenstein',
  //   code: '+423'
  // },
  // {
  //   country: 'lithuania',
  //   code: '+370'
  // },
  {
    country: 'luxembourg',
    code: '+352'
  }
  // {
  //   country: 'mexico',
  //   code: '+52'
  // },
  // {
  //   country: 'monaco',
  //   code: '+377'
  // },
  // {
  //   country: 'macao',
  //   code: '+853'
  // },
  // {
  //   country: 'macedonia',
  //   code: '+389'
  // },
  // {
  //   country: 'madagascar',
  //   code: '+261'
  // },
  // {
  //   country: 'malaysia',
  //   code: '+60'
  // },
  // {
  //   country: 'malawi',
  //   code: '+265'
  // },
  // {
  //   country: 'mali',
  //   code: '+223'
  // },
  // {
  //   country: 'malta',
  //   code: '+356'
  // },
  // {
  //   country: 'morocco',
  //   code: '+212'
  // },
  // {
  //   country: 'martinique',
  //   code: '+596'
  // },
  // {
  //   country: 'mauritius',
  //   code: '+230'
  // },
  // {
  //   country: 'mauritania',
  //   code: '+222'
  // },
  // {
  //   country: 'mayotte',
  //   code: '+262'
  // },
  // {
  //   country: 'federated states of micronesia',
  //   code: '+691'
  // },
  // {
  //   country: 'moldova',
  //   code: '+373'
  // },
  // {
  //   country: 'mongolia',
  //   code: '+976'
  // },
  // {
  //   country: 'montenegro',
  //   code: '+382'
  // },
  // {
  //   country: 'montserrat',
  //   code: '+1664'
  // },
  // {
  //   country: 'mozambique',
  //   code: '+258'
  // },
  // {
  //   country: 'namibia',
  //   code: '+264'
  // },
  // {
  //   country: 'nauru',
  //   code: '+674'
  // },
  // {
  //   country: 'nepal',
  //   code: '+977'
  // },
  // {
  //   country: 'nicaragua',
  //   code: '+505'
  // },
  // {
  //   country: 'niger',
  //   code: '+227'
  // },
  // {
  //   country: 'nigeria',
  //   code: '+234'
  // },
  // {
  //   country: 'niue',
  //   code: '+683'
  // },
  // {
  //   country: 'norway',
  //   code: '+47'
  // },
  // {
  //   country: 'new caledonia',
  //   code: '+687'
  // },
  // {
  //   country: 'new zealand',
  //   code: '+64'
  // },
  // {
  //   country: 'oman',
  //   code: '+968'
  // },
  // {
  //   country: 'netherlands',
  //   code: '+31'
  // },
  // {
  //   country: 'pakistan',
  //   code: '+92'
  // },
  // {
  //   country: 'palau',
  //   code: '+680'
  // },
  // {
  //   country: 'palestine',
  //   code: '+970'
  // },
  // {
  //   country: 'panama',
  //   code: '+507'
  // },
  // {
  //   country: 'papua new guinea',
  //   code: '+675'
  // },
  // {
  //   country: 'paraguay',
  //   code: '+595'
  // },
  // {
  //   country: 'peru',
  //   code: '+51'
  // },
  // {
  //   country: 'french polynesia',
  //   code: '+689'
  // },
  // {
  //   country: 'poland',
  //   code: '+48'
  // },
  // {
  //   country: 'portugal',
  //   code: '+351'
  // },
  // {
  //   country: 'puerto rico',
  //   code: '+1'
  // },
  // {
  //   country: 'qatar',
  //   code: '+974'
  // },
  // {
  //   country: 'united kingdom',
  //   code: '+44'
  // },
  // {
  //   country: 'central african republic',
  //   code: '+236'
  // },
  // {
  //   country: 'czech republic',
  //   code: '+420'
  // },
  // {
  //   country: 'dominican republic',
  //   code: '+1809'
  // },
  // {
  //   country: 'south sudan',
  //   code: '+211'
  // },
  // {
  //   country: 'reunion',
  //   code: '+262'
  // },
  // {
  //   country: 'rwanda',
  //   code: '+250'
  // },
  // {
  //   country: 'romania',
  //   code: '+40'
  // },
  // {
  //   country: 'russia',
  //   code: '+7'
  // },
  // {
  //   country: 'western sahara',
  //   code: '+212'
  // },
  // {
  //   country: 'samoa',
  //   code: '+685'
  // },
  // {
  //   country: 'american samoa',
  //   code: '+1684'
  // },
  // {
  //   country: 'saint barthelemy',
  //   code: '+590'
  // },
  // {
  //   country: 'saint kitts and nevis',
  //   code: '+1869'
  // },
  // {
  //   country: 'san marino',
  //   code: '+378'
  // },
  // {
  //   country: 'saint martin (french part)',
  //   code: '+1599'
  // },
  // {
  //   country: 'saint pierre and miquelon',
  //   code: '+508'
  // },
  // {
  //   country: 'saint vincent and the grenadines',
  //   code: '+1784'
  // },
  // {
  //   country: 'ascension and tristan da cunha',
  //   code: '+290'
  // },
  // {
  //   country: 'saint lucia',
  //   code: '+1758'
  // },
  // {
  //   country: 'sao tome and principe',
  //   code: '+239'
  // },
  // {
  //   country: 'senegal',
  //   code: '+221'
  // },
  // {
  //   country: 'serbia',
  //   code: '+381'
  // },
  // {
  //   country: 'seychelles',
  //   code: '+248'
  // },
  // {
  //   country: 'sierra leone',
  //   code: '+232'
  // },
  // {
  //   country: 'singapore',
  //   code: '+65'
  // },
  // {
  //   country: 'sint maarten',
  //   code: '+1721'
  // },
  // {
  //   country: 'syria',
  //   code: '+963'
  // },
  // {
  //   country: 'somalia',
  //   code: '+252'
  // },
  // {
  //   country: 'sri lanka',
  //   code: '+94'
  // },
  // {
  //   country: 'south africa',
  //   code: '+27'
  // },
  // {
  //   country: 'sudan',
  //   code: '+249'
  // },
  // {
  //   country: 'sweden',
  //   code: '+46'
  // },
  // {
  //   country: 'switzerland',
  //   code: '+41'
  // },
  // {
  //   country: 'suriname',
  //   code: '+597'
  // },
  // {
  //   country: 'svalbard and jan mayen',
  //   code: '+47'
  // },
  // {
  //   country: 'swaziland',
  //   code: '+268'
  // },
  // {
  //   country: 'tajikistan',
  //   code: '+992'
  // },
  // {
  //   country: 'thailand',
  //   code: '+66'
  // },
  // {
  //   country: 'taiwan',
  //   code: '+886'
  // },
  // {
  //   country: 'tanzania',
  //   code: '+255'
  // },
  // {
  //   country: 'british indian ocean territory',
  //   code: '+246'
  // },
  // {
  //   country: 'east timor',
  //   code: '+670'
  // },
  // {
  //   country: 'togo',
  //   code: '+228'
  // },
  // {
  //   country: 'tokelau',
  //   code: '+690'
  // },
  // {
  //   country: 'tonga',
  //   code: '+676'
  // },
  // {
  //   country: 'trinidad and tobago',
  //   code: '+1868'
  // },
  // {
  //   country: 'tunisia',
  //   code: '+216'
  // },
  // {
  //   country: 'turkmenistan',
  //   code: '+993'
  // },
  // {
  //   country: 'turkey',
  //   code: '+90'
  // },
  // {
  //   country: 'tuvalu',
  //   code: '+688'
  // },
  // {
  //   country: 'ukraine',
  //   code: '+380'
  // },
  // {
  //   country: 'uganda',
  //   code: '+256'
  // },
  // {
  //   country: 'uruguay',
  //   code: '+598'
  // },
  // {
  //   country: 'uzbekistan',
  //   code: '+998'
  // },
  // {
  //   country: 'vanuatu',
  //   code: '+678'
  // },
  // {
  //   country: 'venezuela',
  //   code: '+58'
  // },
  // {
  //   country: 'vietnam',
  //   code: '+84'
  // },
  // {
  //   country: 'wallis and futuna',
  //   code: '+681'
  // },
  // {
  //   country: 'yemen',
  //   code: '+967'
  // },
  // {
  //   country: 'djibouti',
  //   code: '+253'
  // },
  // {
  //   country: 'zambia',
  //   code: '+260'
  // },
  // {
  //   country: 'zimbabwe',
  //   code: '+263'
  // }
]
